@if (status.ready) {
	<div [ngClass]="styles.flexColumn">
		<div [ngClass]="styles.flexContainer">
			<div [ngClass]="styles.flexContainer" [tooltip]="(!hasIqCredits ? 'Media_Videos_Transcribe_NoRevIQ' :
					transcribe.isLocked ? 'Media_Videos_Transcribe_Locked' :
					'') | translate" placement="right">
				<vb-toggle-button [attr.name]="'transcribe' + videoTAiIndex" [ariaLabel]="'Media_Videos_Transcribe' | translate" [disabled]="transcribe.isLocked" [(ngModel)]="transcribe.isEnabled" (ngModelChange)="onMetadataChange()">
				</vb-toggle-button>
				<span [ngClass]="styles.toggleIcon" class="vb-icon vb-icon-center vb-icon-transcribe"></span>
				@if (transcribe.isNotPermitted) {
					<div [ngClass]="[styles.flexContainer, styles.toggleLabel]">
						{{ 'Media_Videos_Transcribe' | translate }}
					</div>
				} @else {
					<div [ngClass]="[styles.flexContainer, styles.toggleLabel]">
						{{ 'Media_Videos_Transcribe_Lang' | translate : { '0' : transcribe.languageName } }}
						@if (!transcribe.isLocked && transcribe.isEnabled) {
							<div dropdown [insideClick]="true" class="position-relative" #transcribeLangDropdown="bs-dropdown" vbDropdown>
								<button [attr.id]="'transcribeLangButton' + videoTAiIndex" type="button" class="btn btn-transparent" [ngClass]="styles.transcribeSelectBtn" dropdownToggle>
									<span>{{ 'Select' | translate }}</span>
								</button>
								<div *dropdownMenu [attr.id]="'transcribeLangMenu' + videoTAiIndex" [attr.aria-labelledby]="'transcribeLangButton' + videoTAiIndex" role="menu" class="dropdown-menu vb-scrollbar" [ngClass]="[
										styles.transcribeLangMenu,
										containerClass?.dropdownMenu ? containerClass.dropdownMenu : ''
									]">
									@for (language of transcriptionLanguages; track language) {
										<button type="button" role="menuitem" class="btn btn-transparent dropdown-item" (click)="onTranscribeLanguageClick(language);transcribeLangDropdown.isOpen=false;">
											{{ language.name }}
										</button>
									}
								</div>
							</div>
						}
					</div>
				}
			</div>
		</div>
		@if (transcribe.isEnabled) {
			<div [ngClass]="[styles.flexColumn, styles.paddedLeft]" class="padding-top-15">
				<vb-languages-tags-input id="additionalSubtitleLanguages" name="additionalSubtitleLanguages" [placeholder]="'Media_Videos_Transcribe_AdditionalLanguageSubtitles' | translate" [ngClass]="styles.tagsInput" [customWrapperClass]="styles.tagsInputWrapper" [isThemed]="true" [whitelist]="whitelistedLanguages" [(ngModel)]="transcribe.additionalSubtitleLanguages" (ngModelChange)="onMetadataChange()">
				</vb-languages-tags-input>
			</div>
		}

		@if (!transcribe.isNotPermitted && isMetadataGenerationPermitted) {
			<div [ngClass]="styles.flexColumn" class="margin-top-10 margin-bottom-10">
				<div [ngClass]="styles.flexContainer">
					<vb-toggle-button [attr.name]="'generateAll' + videoTAiIndex" [ariaLabel]="'GenerateAllMetadata' | translate" [disabled]="isMetadataGenerationDisabled" [ngModel]="allChecked" (ngModelChange)="updateAllMetadataFields($event)">
					</vb-toggle-button>
					<span [ngClass]="styles.toggleIcon" class="vb-icon vb-icon-sparkle"></span>
					<button type="button" class="btn-transparent padding-left-0 padding-right-0" display="flex" [ngClass]="styles.toggleLabel" (click)="expand ? expand = false : expand = true">
						{{ 'GenerateAllMetadata' | translate }}
						<span class="glyphicons circle_info margin-left-10" tabindex="0" [tooltip]="'Video_Metadata_Generation_Disabled' | translate" [placement]="'right'">
						</span>
						<span [hidden]="isMetadataGenerationDisabled" class="glyphicons chevron-right" [ngClass]="[styles.chevronIcon, expand ? 'chevron-down': '' ]">
						</span>
					</button>
				</div>
				@if (expand) {
					<div [ngClass]="[styles.flexColumn, styles.paddedLeft]" class="padding-top-15">
						@for(field of enabledFields; track $index) {
							<vb-toggle-button [attr.name]="'generate-' + field + videoTAiIndex" [ariaLabel]="getFieldLabel(field)" [labelName]="getFieldLabel(field)" [labelCssClass]="styles.toggleBtnLabel" [disabled]="isMetadataGenerationDisabled" [ngModel]="fields[field]" (ngModelChange)="updateMetadataField(field, $event)">
							</vb-toggle-button>
						}
					</div>
				}
			</div>
		}

		@if(!hasIqCredits) {
			<div [ngClass]="styles.errorBadge">
				<span class="glyphicons circle_exclamation_mark"></span>
				{{'Media_Videos_NoIqCredits_Transcripts' | translate}}
			</div>

		}
	</div>
}

